import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001';
const STATUS_TTL_MS = 60 * 1000;

let cached = null; // { at, promise }

/**
 * Netgsm santral status for the current user: { enabled, my_extension }.
 * Shared across every CallButton on a page (one request per minute).
 * Never throws — a failure reads as "disabled".
 */
export function getTelephonyStatus({ force = false } = {}) {
  const now = Date.now();
  if (!force && cached && now - cached.at < STATUS_TTL_MS) {
    return cached.promise;
  }
  const promise = axios
    .get(`${API_URL}/api/telephony/status`)
    .then((res) => res.data || { enabled: false })
    .catch(() => ({ enabled: false }));
  cached = { at: now, promise };
  return promise;
}

export function resetTelephonyStatus() {
  cached = null;
}

/** Ring the user's extension, then dial `phone`. Resolves to the call record. */
export async function startCall(phone) {
  const res = await axios.post(`${API_URL}/api/telephony/call`, { phone });
  return res.data;
}

export const telephonyApiUrl = API_URL;
